import {Injectable} from '@angular/core';
import {ApiService} from "../api-service/api-service";


@Injectable()
export class CategoryService {
  defaultBrand: any = {
    "name": "Overdose",
    "icon_image": "assets/img/speakers/bear.jpg",
    "dsp": "Overdose is a Best.",
    "id": 30,
  };

  constructor(public api: ApiService) {

  }

  // 获取品牌列表
  brand(params?: any) {
    let seq = this.api.get('v1/brand', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 获取标签列表
  getTags(params?: any) {
    let seq = this.api.get('v1/tag', params).share();
    seq.subscribe((res: any) => {
      // console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }

  // 获取分类
  getCategoryBrands(params?: any) {
    let seq = this.api.get('v1/brand/category', params).share();
    seq.subscribe((res: any) => {
      console.log(res);
    }, err => {
      console.error(err);
    });

    return seq;
  }


}



// WEBPACK FOOTER //
// ./src/providers/data-service/category-service.ts